// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"135":"group-candidates","347":"group-index","638":"group-admin","883":"group-general"}[chunkId] || chunkId) + "." + {"135":"c2981f45","347":"de06c3c7","492":"44353909","560":"75cfb79c","638":"5ec00e81","883":"4fce8337"}[chunkId] + ".css";
};